import { mainGraphLineColors as datasetColors } from '../utils/constants'
import './Graphs.css'

function Button({onChangeHandler, option, currentIndex}){
    const index = option.index
    return(
        <button value={option.index} className='graph-btn' style={{borderBottom: index===currentIndex && `1px solid ${datasetColors[index]}`}} onClick={onChangeHandler}>
            {option.datasetName && `${option.datasetName}: `}
            <span style={{color: datasetColors[index]}}>{option.columnName}</span>
        </button>)
}

export default function GraphHeaderTabs({changePick, selected, options}) {

    const onChangeHandler = (e) =>  changePick( options[e.currentTarget.attributes.value.value])
    
    return (
        <div className='graphs-tabs'>
            {options.map((option) => 
                <Button onChangeHandler={onChangeHandler} currentIndex={selected.index} option={option} key={`${option.datasetValue}_${option.index}`}/>)
            }
        </div>
    )
}